'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiWarning = function TiWarning(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.3 25.7l-9.9-16.5c-1.3-2.1-3.2-3.3-5.4-3.3s-4.1 1.2-5.4 3.3l-9.9 16.5c-1.3 2.1-1.4 4.5-0.4 6.3 1.1 1.9 3.2 3 5.7 3h20c2.5 0 4.6-1.1 5.7-3 1-1.8 0.9-4.2-0.4-6.3z m-15.3 3.5c-1.4 0-2.6-1.1-2.6-2.5 0-1.5 1.2-2.6 2.6-2.6s2.6 1.1 2.6 2.6c0 1.4-1.2 2.5-2.6 2.5z m2.7-12.3c0 0-2.3 5.8-2.3 5.8-0.1 0.1-0.2 0.2-0.4 0.2s-0.3-0.1-0.4-0.2l-2.3-5.8c-0.2-0.4-0.2-0.7-0.2-1.1 0-1.6 1.3-2.9 2.9-2.9s2.9 1.3 2.9 2.9c0 0.4 0 0.7-0.2 1.1z' })
        )
    );
};

exports.default = TiWarning;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/warning.js
// module id = 3824
// module chunks = 0